import { render, staticRenderFns } from "./ModalCupo.vue?vue&type=template&id=70ac041e&scoped=true&"
import script from "./ModalCupo.vue?vue&type=script&lang=js&"
export * from "./ModalCupo.vue?vue&type=script&lang=js&"
import style0 from "./ModalCupo.vue?vue&type=style&index=0&id=70ac041e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac041e",
  null
  
)

export default component.exports